import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ExistHelpCenterResp } from '../pages/help-center-setting/model/ExistHelpCenterResp';
import { HelpCenterDocBean } from '../pages/help-center-setting/model/HelpCenterDocBean';
import { HelpCenterEditParams } from '../pages/help-center-setting/model/HelpCenterEditParams';
import { HelpCenterResp } from '../pages/help-center-setting/model/HelpCenterResp';
import { HelpCenterSearchParam } from '../pages/help-center-setting/model/HelpCenterSearchParam';

@Injectable({
  providedIn: 'root'
})
export class HelpCenterService {

  private apiUrl = `${environment.customerserviceApiUrl}/helpCenter`;

  constructor(private http: HttpClient) {}

  /** 取得下拉選單（只含 USER 類別） */
  getHelpCenterDropdown(lang: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/dropdown/${lang}`);
  }

  /** 取得所有文章列表（ALL 檢視用） */
  getAllHelpCenterList(): Observable<HelpCenterResp[]> {
    return this.http.get<HelpCenterResp[]>(`${this.apiUrl}/getAllHelpCenterList`);
  }

  /** 根據 permissionCode + lang 查詢（回傳 USER + IT） */
  getHelpCenterByPermissionAndLang(param: HelpCenterSearchParam): Observable<HelpCenterResp> {
    return this.http.post<HelpCenterResp>(
      `${this.apiUrl}/getHelpCenterByPermissionAndLang`,
      param
    );
  }

  /** 根據 permissionCode 查詢（自動帶登入者語系） */
  getHelpCenterByPermissionCode(permissionCode: string): Observable<HelpCenterResp> {
    return this.http.get<HelpCenterResp>(
      `${this.apiUrl}/getByPermissionCode/${permissionCode}`
    );
  }

  /** 更新文章內容（草稿或發佈） */
  updateGuideContent(param: HelpCenterEditParams): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}`, param);
  }

  /**
   * 上傳文件
   * @param file 檔案
   * @param permissionCode 權限碼
   * @param fileName 檔案名稱
   * @param category 文件類別 (USER 或 IT)
   */
  uploadGuideDoc(
    file: File,
    permissionCode: string,
    fileName: string,
    category: string
  ): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);

    const request = {
      permissionCode: permissionCode,
      fileName: fileName,
      category: category
    };

    formData.append('json', JSON.stringify(request));

    return this.http.put<void>(`${this.apiUrl}/uploadDoc`, formData);
  }

  /**
   * 取得文件列表
   * @param permissionCode 權限碼
   * @param category 文件類別 (可選，USER 或 IT)
   */
  getGuideDocList(permissionCode: string,lang?: string, category?: string): Observable<HelpCenterDocBean[]> {
    let params = new HttpParams().set('permissionCode', permissionCode);

    if (category) {
      params = params.set('category', category);
    }
    if (lang) {
      params = params.set('lang',lang);
    }

    return this.http.get<HelpCenterDocBean[]>(
      `${this.apiUrl}/getGuideDocList`,
      { params: params }
    );
  }

  /** 下載文件 */
  downloadDoc(sn: string): Observable<Blob> {
    return this.http.post(
      `${this.apiUrl}/downloadDoc/${sn}`,
      {},
      { responseType: 'blob' }
    );
  }

  /** 刪除文件 */
  deleteDoc(sn: string): Observable<void> {
    return this.http.delete<void>(
      `${this.apiUrl}/deleteDoc`,
      { params: { sn } }
    );
  }

  /** 檢查是否存在文章/文件 */
  existHelpCenter(permissionCode: string, lang: string): Observable<ExistHelpCenterResp> {
    return this.http.get<ExistHelpCenterResp>(
      `${this.apiUrl}/existHelpCenter`,
      { params: { permissionCode, lang } }
    );
  }
}
